import { NgOptimizedImage } from '@angular/common';
import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

 
interface AcessoRapidoDecor {
   corTopo: string;
   corBase: string;
   corTriangulo: string;
}

interface AcessoRapidoItem {
  id: string;
  label: string;
  icone: string;
  link: string;
  linha: string;
  decor: AcessoRapidoDecor;
}

const ICONES = 'assets/images/icones';

const AMARELO = '#FFD93D';
const VERDE = '#6BCB77';
const AZUL = '#00B0FF';
const ROXO = '#7D71FB';

@Component({
  selector: 'app-acesso-rapido-banner',
  templateUrl: './acesso-rapido-banner.component.html',
  styleUrls: ['./acesso-rapido-banner.component.css'],
  imports: [RouterLink, NgOptimizedImage],
})
export class AcessoRapidoBannerComponent {
  readonly itens: AcessoRapidoItem[] = [
    {
      id: 'servicos',
      label: 'Serviços',
      icone: `${ICONES}/servicos.svg`,
      link: '/servicos',
      linha: `${ICONES}/linha-azul.svg`,
      decor: { corTopo: AMARELO, corBase: VERDE, corTriangulo: VERDE },
    },
    {
      id: 'acompanhamento',
      label: 'Acompanhe sua Solicitação',
      icone: `${ICONES}/acompanhe-solicitacao.svg`,
      link: '/acompanhamento',
      linha: `${ICONES}/linha-vermelha.svg`,
      decor: { corTopo: AMARELO, corBase: AMARELO, corTriangulo: AMARELO },
    },
    {
      id: 'ouvidoria',
      label: 'Ouvidoria',
      icone: `${ICONES}/agendamento.svg`,
      link: '/ouvidoria',
      linha: `${ICONES}/linha-amarela.svg`,
      decor: { corTopo: AMARELO, corBase: AZUL, corTriangulo: AZUL },
    },
    {
      id: 'digitais',
      label: 'Serviços Digitais',
      icone: `${ICONES}/servicos-digitais.svg`,
      link: '/servicos-digitais',
      linha: `${ICONES}/linha-verde.svg`,
      decor: { corTopo: AMARELO, corBase: ROXO, corTriangulo: ROXO },
    },
  ];
}
